module.exports = __webpack_public_path__ + "static/media/ChangeCasetteLogo.88a11f79.svg";